export { default } from './isImmutableIndexedSeq'
